module.exports = __webpack_public_path__ + "img/pic_200215_2.0be32349.jpg";